<template>
	<div class="ProductCell">
		<div class="header pb-12 flex flex-just-between">
			<div class="flex flex-align-center">
				<el-tooltip
					class="item"
					effect="light"
					:content="
						row.platform_id == 1
							? `达人信息  粉丝量 ${row.fans_num} | 月橱销量 ${row.month_sale} | 月橱销售额 ${row.month_live_sale}`
							: `达人信息  粉丝量 ${row.fans_num} | 月订单量 ${row.month_sale} | 月销售额 ${row.month_live_sale}`
					"
					placement="bottom-start"
					:disabled="tabName !== '1'"
				>
					<div class="talent-info flex flex-align-center" v-if="row.anchor_id != 0" @click="showdetailDrawer">
						<platform-icon :platformId="row.platform_id" class="mr-8"></platform-icon>
						<yx-avatar :size="24" :src="row.head" />
						<span class="ml-6">带货达人：</span>
						<span class="font-bold">{{ row.anchor_name }}</span>
					</div>
					<div class="flex" v-else>
						<yx-avatar :size="24" :src="row.head" />
						<span class="ml-6">无达人信息</span>
					</div>
				</el-tooltip>
				<span>&nbsp;&nbsp;>&nbsp;&nbsp;(达人招商：</span>
				<span class="font-bold">{{ row.nick_name || '-' }}</span>
				<span>)</span>
				<template v-if="row.team_institution_id && row.team_institution_id != 0">
					<p class="ml-16">|</p>
					<div class="ml-16 colonel">
						<span>团长渠道：</span>
						<yx-avatar :size="24" :placeholder="teamLeaderChannelPlaceholder(row)" />
						<el-tooltip :content="row.institution_info.institution_name" placement="top">
							<div class="name ellipsis ml-4">{{ row.institution_info.institution_name }}</div>
						</el-tooltip>
					</div>
				</template>
				<p class="ml-16">|</p>
				<p class="ml-16">
					<span>{{ drName }}：</span>
					<span class="font-bold">{{ row.partner_role_name || '-' }}</span>
				</p>
				<p class="ml-16">
					<span>{{ zsName }}：</span>
					<span class="font-bold">{{ row.operating_name || '-' }}</span>
				</p>
				<p class="ml-16">|</p>
				<el-tooltip placement="bottom-start" :disabled="!['2', '3', '4'].includes(row.order_cooperate_status)">
					<div slot="content">
						<span>协作样单号（发送给商家查询进度）：{{ 'PTS' + row.sample_sn }}</span>
						<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy('PTS' + row.sample_sn)"></i>
					</div>
					<p class="ml-16">
						<span>订单号：</span>
						<span>{{ row.sample_sn }}</span>
					</p>
				</el-tooltip>
			</div>
			<div class="flex flex-align-center">
				<btn-state v-if="row.order_other_status != 7" :row="row" :btnText="row.other_status_desc" :tabName="tabName"></btn-state>
				<p v-if="row.close_desc" class="ml-10">{{ '(' + row.close_desc + ')' }}</p>
				<p class="ml-10 yx-color-text-primary font-bold">{{ row.order_other_status_desc }}</p>
			</div>
		</div>
		<div class="footer flex flex-just-between pt-10">
			<product-box :isShow="true" :row="row" :tabName="tabName" :showTag="row.is_sync == 1" :is_good_type="1"></product-box>
			<div class="ml-40" v-if="tabName === '3'">
				<!-- 先去掉 后续在改造 -->
				<!-- <p class="fz-14 flex flex-align-center" v-if="isDrPartnerDataView && rate_status">
					<span class="yx-color-text-secondary flex flex-align-center"
						>提成比
						<el-tooltip class="item" effect="dark" content="【原始服务费率-二级团长服务费率】*达人分成比" placement="top">
							<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
						</el-tooltip>
						：</span
					>
					<span class="yx-color-text-primary">{{ row.partner_rate }}%</span>
				</p> -->
				<div v-if="tabName === '3'">
					<p v-if="$auth.hasPermi('system:goods-ServiceRate')">
						<span class="yx-color-info">服务费</span>
						<span class="ml-10 yx-color-text-primary">{{ row.service_rate }}%</span>
					</p>
					<p>
						<span class="yx-color-info">总销量</span>
						<span class="ml-10 yx-color-text-primary">{{ row.sales }}</span>
					</p>
				</div>
			</div>
			<div class="empty" v-if="tabName === '0'">
				<p class="fz-14">
					<span class="yx-color-text-secondary">总销量：</span>
					<span class="yx-color-text-primary">{{ row.sales }}</span>
				</p>
			</div>
			<div class="fz-14 des" v-if="tabName === '1'">
				<div v-if="row.is_refuse_delivery == '1'">
					<p class="yx-color-black font-bold">拒绝发货</p>
					<span>原因：</span>
					<span class="ml-10">{{ row.refuse_delivery_content }}</span>
				</div>
				<div v-else>
					<div class="yx-color-black font-bold flex flex-align-center">
						<span>{{ deliveryStatusDesc }}</span>
						<span class="more-parcel" v-if="showMore(row)">多包裹</span>
						<partnerTag
							v-if="row?.cooperate_partner_info?.audit_role == 'rd'"
							:status="row?.cooperate_partner_info?.apply_status"
							:desc="row?.cooperate_partner_info?.apply_status_desc"
							:reason="row?.cooperate_partner_info?.apply_status == 20 ? row?.cooperate_partner_info?.finish_reason : ''"
							class="ml-4"
						/>
						<Tag
							:status="row.order_cooperate_status"
							:desc="row.order_cooperate_status_desc"
							:reason="syncReason"
							class="ml-4"
							v-if="row.cooperate_partner_info?.audit_role != 'rd' && injectCooperationStatus() && vuex_isshopurl && !$isSp(row.platform_id)"
						/>
					</div>
					<p v-if="row.order_other_status === 11" class="font-h4-regular yx-color-text-secondary">原因：{{ row.refuse_reason }}</p>
					<div class="warp flex flex-align-center fz-12">
						<div class="ellipsis" style="max-width: 130px" v-if="delivery_info">{{ delivery_info }}</div>
						<div class="primary-color cursor-pointer" v-if="showLogistics(row)" @click="showLogisticsDetailDrawer(row)">样品详情</div>
					</div>
					<p class="warp fz-12" v-if="row.shipping_company">
						<span>{{ row.shipping_company }}</span>
						<span class="ml-10">{{ row.shipping_sn }}</span>
					</p>
				</div>
				<div class="mt-4" v-if="notShipped">
					<div class="flex">
						<p class="yx-color-text-secondary">{{ row.product_type == '4' ? '团长' : '商家' }}跟进：</p>
						<div>
							<div class="flex">
								<p class="yx-color-text-primary ml-4" v-if="showContact">已联系{{ row.product_type == '4' ? '团长' : '商家' }}</p>
								<p class="yx-color-warning ml-4" v-if="showNotContact">未联系{{ row.product_type == '4' ? '团长' : '商家' }}</p>
								<div class="flex flex-align-center contact-tag ml-4 mt-2" v-auth="['system:sampleOrder:remark']">
									<div class="track-record"></div>
									<p class="fz-12 pointer ml-4" @click="settingRemarks(row)">跟进备注</p>
								</div>
							</div>
							<div class="ml-48" v-if="showContact && row.contact_time && row.contact_time !== '0'">{{ row.contact_time | formatDateTime }}</div>
						</div>
					</div>
				</div>
				<div class="mt-4 flex flex-align-center">
					<el-tooltip class="item" effect="dark" :disabled="!row.buyer_remark" :content="`${row.buyer_remark}`" placement="top-start">
						<p class="fz-14 ellipsis">
							<span class="yx-color-text-secondary">申样备注：</span>
							<i class="el-icon-edit-outline cursor-pointer mr-4" @click="setSampleRemarks && setSampleRemarks(row)"></i>
							<span class="yx-color-text-primary">{{ row.buyer_remark ? row.buyer_remark : '无' }}</span>
						</p>
					</el-tooltip>
				</div>
			</div>
			<div v-if="tabName === '2'">
				<p v-if="$auth.hasPermi('system:goods-ServiceRate')">
					<span class="yx-color-info">服务费率</span>
					<span class="ml-10 yx-color-text-primary">{{ row.service_rate }}%</span>
				</p>
				<p>
					<span class="yx-color-info">总销量</span>
					<span class="ml-10 yx-color-text-primary">{{ row.sales }}</span>
				</p>
				<p v-if="row.url_check_status == linkStatus.tobeCheck">
					<span class="yx-color-info">{{ '待校验链接' }}</span>
				</p>
				<p v-if="row.url_check_status == linkStatus.finished && !isKsPlatform && !$isSp(row.platform_id)" class="plink">
					<span class="yx-color-info">{{ '带货链接' }}</span>
					<el-tooltip class="item" effect="dark" :content="row.partner_url" placement="top-start">
						<a class="ml-10 yx-color-text-primary link ellipsis" :href="row.partner_url" target="_blank">{{ row.partner_url }}</a>
					</el-tooltip>
				</p>
			</div>
			<div class="flex" v-if="tabName === '3'">
				<div class="ml-30">
					<p class="nowarp">
						<span class="yx-color-info">开始合作时间：</span>
						<span class="ml-10 yx-color-text-primary">{{ row.cooperate_start_time }}</span>
						<i class="el-icon-edit-outline ml-10 pointer outline" @click="editTime()"></i>
					</p>
					<p class="nowarp">
						<span class="yx-color-info">终止合作时间：</span>
						<span class="ml-10 yx-color-text-primary">{{ row.cooperate_end_time }}</span>
					</p>
					<p class="plink" v-if="!isKsPlatform && !$isSp(row.platform_id)">
						<span class="yx-color-info">{{ '带货链接' }}</span>
						<el-tooltip class="item" effect="dark" :content="row.partner_url" placement="top-start">
							<a class="ml-10 yx-color-text-primary link ellipsis" :href="row.partner_url" target="_blank">{{ row.partner_url }}</a>
						</el-tooltip>
					</p>
				</div>
			</div>
			<div>
				<p class="fz-14">
					<span class="yx-color-text-secondary">操作人：</span>
					<span class="yx-color-text-primary">{{ row.operator_name }}</span>
				</p>
				<p class="fz-14">
					<span class="yx-color-text-secondary">操作时间：</span>
					<span class="yx-color-text-primary">{{ row.operator_time }}</span>
				</p>
				<p class="mt-4">
					<span>
						合作ID：
						<span class="hover cursor-pointer yx-color-text-primary" @click="skipCooperate(row)">
							{{ row.cooperate_id }}
							<i class="el-icon-arrow-right"></i>
						</span>
					</span>
				</p>
			</div>
			<div class="line"></div>
			<div class="align-right">
				<div v-for="(item, index) in btnArr.default" :key="index">
					<el-tooltip class="item" effect="dark" :content="content" :disabled="item.label != '复制链接' || !content" placement="left">
						<el-button :key="index" :type="item.type" :disabled="item.disabled" :plain="item.plain" @click="click(item)">
							<div :class="[item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '', item.notSelf ? 'notSelf' : '']">
								{{ item.label }}
							</div>
						</el-button>
					</el-tooltip>
				</div>
				<el-dropdown v-if="btnArr.more.length" @command="click">
					<span class="el-dropdown-link yx-color-primary pointer">
						更多
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="item" v-for="(item, index) in btnArr.more" :key="index">
							<el-tooltip class="item" effect="dark" :content="content" :disabled="item.label != '复制链接' || !content" placement="left">
								<el-button :key="index" :type="item.type" :disabled="item.disabled" :plain="item.plain">
									<div
										:class="[item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '', item.notSelf ? 'notSelf' : '']"
									>
										{{ item.label }}
									</div>
								</el-button>
							</el-tooltip>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<div class="sales flex mt-10 flex-just-center" v-if="tabName == '3'">
			<div class="flex">
				<p class="mr-30">
					<span>预估销量(件)</span>
					<span class="ml-10 font-bold yx-color-text-primary">{{ row.total_num }}</span>
				</p>
				<p class="mr-30">
					<span>预估销售额(元)</span>
					<span class="ml-10 font-bold yx-color-text-primary">{{ row.total_pay_amount }}</span>
				</p>
				<template v-if="$auth.hasPermi('system:goods-ServiceRate')">
					<p class="mr-30">
						<span>
							预估服务费收入(元)
							<el-tooltip content="订单付款金额*原始服务费率 ，未扣除技术服务费" placement="top">
								<i class="iconfont icon-a-info-circle-oxinxi-xian"></i>
							</el-tooltip>
						</span>
						<span class="ml-10 font-bold yx-color-text-primary">{{ row.partner_estimated_commission_income }}</span>
					</p>
					<p class="mr-30">
						<span>
							预估服务费支出(元)
							<el-tooltip content="订单付款金额*二级团长服务费率" placement="top">
								<i class="iconfont icon-a-info-circle-oxinxi-xian"></i>
							</el-tooltip>
						</span>
						<span class="ml-10 font-bold yx-color-text-primary">{{ row.partner_estimated_commission_pay }}</span>
					</p>
				</template>
				<p class="mr-30" v-if="$auth.hasPermi('system:goods-ServiceRate')">
					<span>
						预估到手服务费(元)
						<el-tooltip class="item" effect="dark" content="订单付款金额*（原始服务费率-二级团长服务费率），并扣除技术服务费" placement="top">
							<i class="iconfont icon-a-info-circle-oxinxi-xian"></i>
						</el-tooltip>
					</span>
					<span class="ml-10 font-bold yx-color-text-primary">{{ row.partner_estimated_commission }}</span>
				</p>
			</div>
			<div class="fz-12 flex flex-align-center yx-color-text-regular">
				<p class="mr-10">数据更新时间：{{ row.achievement_day }}</p>
				<el-tooltip class="item" effect="dark" content="每日更新前一天的数据" placement="top">
					<i class="iconfont icon-a-info-circle-oxinxi-xian"></i>
				</el-tooltip>
			</div>
		</div>
		<el-dialog title="修改开始合作时间" :visible.sync="addVisible" :append-to-body="true" width="420px" @close="resetForms">
			<div class="tips flex mb-20">
				<i class="iconfont mt-2 mr-6 icon-a-info-circlexinxi-mian yx-color-primary"></i>
				<p>开始合作时间最多支持选择到30天前，系统将根据“开始合作时间”统计该商品的带货数据。</p>
			</div>
			<el-form :model="editFrom" ref="editFrom" :rules="editRules">
				<el-form-item label="开始合作时间：" label-width="130px" prop="start_time">
					<el-date-picker
						v-model="timesTamp"
						type="datetime"
						@change="changeTimed"
						value-format="timestamp"
						placeholder="选择开始合作时间"
					></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addVisible = false">取 消</el-button>
				<el-button type="primary" @click="editConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import productBox from '@/components/common/productBox';

import btnState from '@/components/common/btnState';
import mixin from '@/components/tableCells/mixin.js';
import { mapGetters, mapState } from 'vuex';
import { linkStatus, deliveryStatus, PLATFORM_KS, zsRoleType, drRoleType, sampleStutas } from '@/utils/dataMap';
import { updateStartTime } from '@/api/cooperationProgress.js';
import Tag from './tag.vue';
import partnerTag from './partnerTag.vue';
import { copy } from '@/utils/common';
export default {
	components: {
		productBox,
		btnState,
		Tag,
		partnerTag,
	},

	name: 'ProductCell',
	inject: {
		injectCooperationStatus: {
			default: () => false,
		},
		injectIsSampleOrder: {
			default: () => false,
		},
	},
	mixins: [mixin],
	data() {
		return {
			linkStatus,
			editFrom: {
				start_time: '',
			},
			editRules: {
				start_time: [{ required: true, message: '请填写开始合作时间', trigger: 'blur' }],
			},
			timesTamp: '',
			addVisible: false,
			month_sale: 223232,
		};
	},
	computed: {
		...mapState(['vuex_userInfo', 'vuex_isshopurl']),
		...mapGetters(['isDarenPartner']),
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		drName() {
			return drRoleType.name;
		},
		isSampleTable() {
			return this.tabName == '2';
		},
		content() {
			if (this.$isSp(this.row.platform_id)) {
				return '';
			}
			// 保持不变
			return this.isDarenPartner
				? this.row.source_type === '2'
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
		btnArr() {
			const { row: { operations = [] } = {} } = this;
			return {
				default: operations.slice(0, 3),
				more: operations.slice(3),
			};
		},
		notShipped() {
			return this.row?.delivery_status == deliveryStatus.notShipped;
		},
		delivery_info() {
			const { row } = this;
			return row.delivery_info && row.delivery_info[0] ? row.delivery_info[0].context : '';
		},
		showMore() {
			return ({ order_num }) => Number(order_num) > 1;
		},
		showLogistics() {
			return ({ delivery_address, order_other_status }) =>
				order_other_status ? ![6, 7].includes(order_other_status) : delivery_address && delivery_address.area;
		},
		isKsPlatform() {
			return +this.row?.platform_id === +PLATFORM_KS.value;
		},
		zsName() {
			return zsRoleType.name;
		},
		showContact() {
			const { row } = this;
			return row.contact_status === '1';
		},
		showNotContact() {
			const { row } = this;
			return row.contact_status === '0';
		},
		deliveryStatusDesc({ row }) {
			return +row.order_other_status === 10 || +row.order_other_status === 11 ? row.order_other_status_desc : row.delivery_status_desc;
		},
		syncReason({ row }) {
			return +row.order_cooperate_status === 0 ? '请前往[合作店铺-店铺列表]发送样品协作，绑定后即可协作样品订单。' : row.cooperate_failure_reason;
		},
	},
	methods: {
		click(item) {
			if (item.click) {
				item.click(this.row, this.tabName);
			}
		},
		showdetailDrawer() {
			this.row.operations.showdetailDrawer(this.row.anchor_id);
		},
		showLogisticsDetailDrawer(row) {
			this.row.operations.showLogisticsDetailDrawer(row);
		},
		settingRemarks(row) {
			this.row.operations.settingRemarks(row);
		},
		setSampleRemarks(row) {
			this.row.setSampleRemarks(row);
		},

		editTime() {
			this.addVisible = true;
		},
		changeTimed(val) {
			this.editFrom.start_time = val ? val / 1000 : 0;
		},
		editConfirm() {
			this.$refs.editFrom.validate(async valid => {
				if (valid) {
					this.editFrom.cooperate_id = this.row.cooperate_id;
					const { code } = await updateStartTime(this.editFrom);
					if (code !== 0) return;
					this.$Bus.$emit('editLiveTime');
					this.$message.success('修改成功');
					this.addVisible = false;
				}
			});
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		resetForms() {
			this.timesTamp = '';
			this.editFrom.start_time = '';
			this.$refs['editFrom'].resetFields();
		},
		skipCooperate({ cooperate_id, status }) {
			const combinedMap = new Map([
				['1', { toBeSelected: 0 }],
				['2', { sampleToBeSent: 1 }],
				['3', { toBeDelivered: 2 }],
				['4', { delivered: 3 }],
			]);
			let tabid = Object.values(combinedMap.get(status))[0];
			const { href } = this.$router.resolve({ path: '/cooperationProgress/list', query: { cooperate_id, tabid } });
			window.open(href, '_blank');
		},
		teamLeaderChannelPlaceholder(row) {
			//row.institution_info返回的是对象
			return row?.institution_info?.institution_name ? row.institution_info.institution_name[0] : '';
		},
	},
};
</script>

<style lang="less" scoped>
.header {
	border-bottom: 1px solid #eeeeee;
}

.line {
	width: 1px;
	background-color: #eeeeee;
	margin-left: 40px;
	margin-right: 80px;
}

.sales {
	width: 100%;
	padding: 12px 18px;
	background: rgba(0, 83, 219, 0.03);
	justify-content: space-between;
	border-radius: 2px;
}

.empty {
	min-width: 300px;
}

.des {
	width: 270px;
}

.warp {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.plink {
	display: flex;
}

.link:hover {
	color: @color-success;
}

.ellipsis {
	width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.nowarp {
	white-space: nowrap;
}

.align-right {
	text-align: right;
	width: 100px;
}

.talent-info {
	cursor: pointer;

	&:hover {
		color: @color-primary;
	}
}

.outline:hover {
	color: @color-primary;
}

.tips {
	background: rgba(0, 83, 219, 0.03);
	border: 1px solid @color-primary;
	padding: 14px 16px;
}

.more-parcel {
	color: @color-primary;
	background-color: #e9f1ff;
	border-radius: 2px;
	padding: 0 4px;
	height: 18px;
	line-height: 18px;
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	margin-left: 4px;
}

.colonel {
	display: flex;
	align-items: center;

	.name {
		color: #333;
		max-width: 100px;
		width: auto !important;
	}
}

.contact-tag {
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	text-align: center;
	padding: 0px 3px;
	font-weight: 400;
	background-color: #ebf2fd;
	color: @color-primary;
}
</style>
